import {Button, Form, InputGroup} from 'react-bootstrap';
import {ArrowRight, ArrowLeft} from 'react-bootstrap-icons';
import {useState} from 'react';

const ContactForm = ({name, setName, phone, setPhone, onSubmit}) => {
    const [step, setStep] = useState(0);
    const maskPhone = (value) => {
        return value.replace(/\D/g, '')
            .replace(/^(\d)/, '($1')
            .replace(/^(\(\d{2})(\d)/, '$1) $2')
            .replace(/(\d{5})(\d{1,5})/, '$1-$2')
            .replace(/(-\d{4})\d+?$/, '$1');
    };

    const handlePhoneChange = (e) => {
        setPhone(maskPhone(e.target.value));
    };

    const handleSubmit = () => {
        onSubmit()?.then(() => setStep(2));
    };

    return (
        <div className={`contact-form-slider step-${step}`}>
            <div className="slides">
                <div className="slide">
                    <InputGroup className="mb-3">
                        <Form.Control
                            type="text"
                            value={phone}
                            onChange={handlePhoneChange}
                            placeholder="Número de telefone"
                        />
                        <Button
                            variant="primary"
                            onClick={() => setStep(1)}
                            disabled={!phone}
                            aria-label="Avançar"
                        >
                            <ArrowRight />
                        </Button>
                    </InputGroup>
                </div>
                <div className="slide">
                    <InputGroup className="mb-3">
                        <Button
                            variant="outline-secondary"
                            onClick={() => setStep(0)}
                            aria-label="Voltar"
                        >
                            <ArrowLeft />
                        </Button>
                        <Form.Control
                            type="text"
                            value={name}
                            onChange={e => setName(e.target.value)}
                            placeholder="Seu nome"
                        />
                        <Button
                            variant="success"
                            onClick={handleSubmit}
                            disabled={!name || !phone}
                            aria-label="Enviar"
                        >
                            Enviar
                        </Button>
                    </InputGroup>
                </div>
                <div className="slide text-center d-flex align-items-center justify-content-center">
                    <p className="mb-0 fw-bold">Seu contato foi recebido 🎉</p>
                </div>
            </div>
        </div>
    );
};

export default ContactForm;
